







































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { StudentCreate as IStudentCreate } from "@/api-v2/course/models/student-create";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import { Student as IStudent } from "@/api-v2/course/models";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomInputPhone from "@/components/form/CustomInputPhone.vue";
import UserAvatar from "@/components/user/UserAvatar.vue";
import { FileItem as IFileItem } from "@/api/models";
import FileManager from "@/components/files/FileManager.vue";
import { screenWidth } from "@/plugins/variables";

@Component({
  components: {
    FileManager,
    UserAvatar,
    CustomInputPhone,
    CustomDatepicker,
    CSingleSelect,
    CField,
    CBlock,
    CPage
  }
})
export default class StudentForm extends Vue {
  @Prop() companyId!: string;
  @Prop() student?: IStudent;
  usersList: UsersListClass = new UsersListClass(
    {},
    this.student && this.student.user ? this.student.user.id : undefined
  );

  selectedUserPhoto!: IFileItem | null;
  isShowFileManager: boolean = false;

  studentForm: IStudentCreate = {
    companyId: this.companyId,
    firstName: "",
    lastName: "",
    middleName: "",
    userId: "",
    birthday: undefined,
    gender: undefined,
    email: "",
    phone: "",
    photoId: ""
  };

  get screenWidth() {
    return screenWidth();
  }

  data() {
    return {
      selectedUserPhoto:
        this.student && this.student?.photoId
          ? { url: this.student.photoUrl, id: this.student.photoId }
          : undefined
    };
  }

  @Watch("studentForm", { immediate: true, deep: true })
  checkStudentForm() {
    this.$emit("input", this.studentForm);
  }

  selectFile(file: IFileItem) {
    this.selectedUserPhoto = file;
    this.studentForm.photoId = file.id;
    if (this.screenWidth < 992) {
      this.isShowFileManager = false;
    }
  }

  fileDelete() {
    this.studentForm.photoId = "";
    this.selectedUserPhoto = null;
  }

  created() {
    if (this.student) {
      this.studentForm = this.student as IStudentCreate;
    }
  }
}
